import type { StudioNewProjectFormInput } from "../workflow/studio-workflow.js";
import type { GuidedStudioDemoPreset } from "./guided-demo-presets.js";

export type GuidedStartMethod = "agency" | "intake";

export interface GuidedNewProjectFormInput {
  readonly businessName: string;
  readonly contact: string;
  readonly projectType: string;
  readonly startMethod: GuidedStartMethod;
  readonly demoPreset?: GuidedStudioDemoPreset | null;
}

export function guidedToStudioFormInput(input: GuidedNewProjectFormInput): StudioNewProjectFormInput {
  const preset = input.demoPreset;
  const contact = input.contact.trim();
  const email = contact.includes("@") ? contact : (preset?.primaryEmail ?? "");
  const phone = contact.includes("@") ? (preset?.primaryPhone ?? "") : (contact || preset?.primaryPhone || "");
  const primaryService = input.projectType.trim() || preset?.projectType || "General services";
  const serviceArea = preset?.serviceAreas[0] ?? "To be confirmed in Facts step";

  const businessName = (input.businessName.trim() || preset?.businessName || "").trim();
  return {
    businessName,
    primaryService,
    serviceArea,
    contactEmail: email,
    primaryPhone: phone || undefined,
    services: preset?.services.map((name) => ({ name })),
    serviceAreas: preset?.serviceAreas.map((name) => ({ name })),
    description: preset?.description,
    primaryEvidenceType: preset?.primaryEvidenceType,
    clientEntityName: businessName,
    scopeSummary: `Initial ${primaryService} website scope`,
    ownerLabel: "Agency owner",
    builderPath: "ENREIN_GENERATE",
    targetOutcome: "Launch an approved client website revision",
    sitePackageId: "package-standard-5",
  };
}

export const GUIDED_PROJECT_TYPES = [
  "HVAC",
  "Plumbing",
  "Roofing",
  "Landscaping",
  "Cleaning",
  "Electrical",
  "Pest control",
  "General contractor",
] as const;
